export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './inventoryManagementCountData.service';
import { InventoryManagementCountDataService } from './inventoryManagementCountData.service';
export * from './inventoryManagementDevicePairing.service';
import { InventoryManagementDevicePairingService } from './inventoryManagementDevicePairing.service';
export * from './inventoryManagementDevices.service';
import { InventoryManagementDevicesService } from './inventoryManagementDevices.service';
export * from './inventoryManagementImages.service';
import { InventoryManagementImagesService } from './inventoryManagementImages.service';
export * from './inventoryManagementInventoryItems.service';
import { InventoryManagementInventoryItemsService } from './inventoryManagementInventoryItems.service';
export * from './inventoryManagementLocations.service';
import { InventoryManagementLocationsService } from './inventoryManagementLocations.service';
export const APIS = [AuthenticationService, InventoryManagementCountDataService, InventoryManagementDevicePairingService, InventoryManagementDevicesService, InventoryManagementImagesService, InventoryManagementInventoryItemsService, InventoryManagementLocationsService];
